/** Entity fields supported by catalog-backed filters. */
export const ENTITY_FILTER_FIELDS = [
  { value: 'kind', label: 'Kind' },
  { value: 'spec.type', label: 'Type' },
  { value: 'spec.lifecycle', label: 'Lifecycle' },
  { value: 'spec.owner', label: 'Owner' },
  { value: 'spec.system', label: 'System' },
  { value: 'metadata.tags', label: 'Tags' },
] as const;

export type EntityFilterField = (typeof ENTITY_FILTER_FIELDS)[number]['value'];
